export default "__VITE_ASSET__965c04f2__"